export class OfferSwitcher {
    constructor(element) {
        this.offer = $(element);

        this.setElementClasses();

        this.basketItem = this.offer.closest('.' + this.BASKET_ITEM_CLASS);

        this.bind();
    }
    name() {
        return 'OfferSwitcher';
    }
    setElementClasses() {
        this.BASKET_ITEM_CLASS = 'js-basket_item';

        this.DROP_BLOCK_CLASS = 'js-drop';
        this.CLOSE_BUTTON_CLASS = 'js-toggle';
    }
    bind() {
        this.offer.off('click').on('click', (event) => this.changeOffer.call(this, event));
    }
    changeOffer(event) {
        event.preventDefault();

        let $this = this,
            id = this.offer.data('id'),
            closeButton = this.offer.closest('.' + this.DROP_BLOCK_CLASS).find('.' + this.CLOSE_BUTTON_CLASS);

        if (id === this.basketItem.data('product-id')) {
            // Значит мы ткнули на уже выбранное ТП
            closeButton.click();
            return;
        }

//        $('body').preloader('show');

        this.basketItem.preloader('show', 'block');
        $('.' + this.BAG_DROP_CLASS).preloader('show', 'block');

        $.post(
            '/ajax/basket/change_item_offer/' + this.basketItem.data('item') + '/',
            {offer_id: id},
            (result) => {
                this.basketItem.preloader('hide', 'block');
                $('.' + this.BAG_DROP_CLASS).preloader('hide', 'block');

                if (result.type !== 'success') {
                    console.error(result.value);

                    return;
                }

                $this.offer.trigger('mario.basket_item.offer.changed');
            },
            'json'
        );

        closeButton.click();
    }
}